import { withStyles } from '@material-ui/core/styles';
import BaseTooltip from '@material-ui/core/Tooltip';

export const Tooltip = withStyles(() => ({
  tooltip: {
    maxWidth: '40ch',
    background: '#000000',
    marginLeft: '10px',
  },
}))(BaseTooltip);
